import * as types from "../mutation-types";
import store from "../index";
import LogRocket from 'logrocket';

const state = {
    jwt: '',
    authenticationErrorMsg: '',
    pendingOrgReq: [],
    isSuperAdmin: false
};
const getters = {
    isAuthenticated: state => state.jwt !== '',
    getJwt: state => state.jwt,
    getPendingOrgReq: state => state.pendingOrgReq,
    isSuperAdmin: state => state.isSuperAdmin
};
const actions = {

    async LogIn({ commit }, user) {
        await axios.post('user/login', {
            email: user.email,
            password: user.password
        }).then(r => {
            commit(types.SET_JWT_TOKEN, r.data.response.data.token);
            commit(types.SET_AUTHENTICATION_ERROR, '');
            LogRocket.identify(r.data.response.data.user.id.toString() || user.email, {
                name: r.data.response.data.user.name || '',
                email: user.email
            });
        }).catch(error => {
            commit(types.SET_AUTHENTICATION_ERROR, error.response.data.response.error.error_msg);
            reject()
        });
    },

    async LogInSuperAdmin({ commit }, user) {
        await axios.post('user/login/admin', {
            email: user.email,
            password: user.password
        }).then(r => {
            commit(types.SET_JWT_TOKEN, r.data.response.data.token);
            commit(types.SET_PENDING_ORG_REQ, r.data.response.data.organisations.pending);
            commit(types.SET_SUPER_ADMIN);
            commit(types.SET_AUTHENTICATION_ERROR, '');
            LogRocket.identify(r.data.response.data.user.id.toString() || user.email, {
                name: r.data.response.data.user.name || 'Super Admin',
                email: user.email
            });
        }).catch(error => {
            commit(types.SET_AUTHENTICATION_ERROR, error.response.data.response.error.error_msg);
        });
    },

    async GoogleLogIn({ commit }, user) {
        await axios.post('user/login/google', {
            email: user.email,
            google_id: user.google_id,
            google_token: user.google_token,
            first_name: user.first_name,
            last_name: user.last_name,
            photo_url: user.photo_url
        }).then(r => {
            commit(types.SET_JWT_TOKEN, r.data.response.data.token);
            commit(types.SET_AUTHENTICATION_ERROR, '');
            LogRocket.identify(r.data.response.data.user.id.toString() || user.email, {
                name: `${user.first_name} ${user.last_name}`.trim(),
                email: user.email
            });
        }).catch(error => {
            commit(types.SET_AUTHENTICATION_ERROR, error.response.data.response.error.error_msg + " " + error.response.data.response.error.msg);
            reject()
        });
    },

    setJwt({ commit }, jwt) {
        commit(types.SET_JWT_TOKEN, jwt);
        commit(types.SET_AUTHENTICATION_ERROR, '');
    },

    async LogOut({ commit }) {
        const selectedLanguage = localStorage.getItem('localeLanguage');
        commit(types.UNSET_JWT_TOKEN, '');
        commit(types.UNSET_PENDING_ORG_REQ, '')
        commit(types.UNSET_SUPER_ADMIN, '')
        localStorage.clear();
        localStorage.setItem('localeLanguage', selectedLanguage || 'en');
        window.location.replace('/login');
    },

    async SetAuthError({ commit }, error_msg) {
        commit(types.SET_AUTHENTICATION_ERROR, error_msg);
    }

};
const mutations = {
    [types.SET_JWT_TOKEN](state, jwt) {
        state.jwt = jwt
        window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + state.jwt;
    },
    [types.UNSET_JWT_TOKEN](state) {
        state.jwt = ''
    },
    [types.SET_AUTHENTICATION_ERROR](state, error_msg) {
        state.authenticationErrorMsg = error_msg
    },
    [types.SET_PENDING_ORG_REQ](state, pendingOrgReq) {
        state.pendingOrgReq = pendingOrgReq
    },
    [types.UNSET_PENDING_ORG_REQ](state) {
        state.pendingOrgReq = []
    },
    [types.SET_SUPER_ADMIN](state) {
        state.isSuperAdmin = true
    },
    [types.UNSET_SUPER_ADMIN](state) {
        state.isSuperAdmin = false
    },
};
export default {
    state,
    getters,
    actions,
    mutations
};
